import { AuthService } from './authentication.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiUxService {
  private apiUxUrl = environment.apiUxUrl;
  private httpOptions = {
    headers: {
      Authorization: '',
    },
  };

  constructor(private http: HttpClient) {}

  buildUrl(path: string) {
    return this.apiUxUrl + path;
  }

  refreshHttpOptions() {
    this.httpOptions = {
      headers: {
        Authorization: `Bearer ${this.getAuthToken()}`,
      },
    };
  }

  getAuthToken(): string {
    const token = sessionStorage.getItem(AuthService.TOKEN_KEY);
    if (token) {
      return token;
    } else {
      throw new Error('Not logged in');
    }
  }

  get<T>(path: string) {
    this.refreshHttpOptions();
    return this.http.get<ApiUxRetour<T>>(this.buildUrl(path), this.httpOptions).pipe(map(result => result.data));
  }

  delete(path: string) {
    this.refreshHttpOptions();
    return this.http.delete(this.buildUrl(path), this.httpOptions);
  }

  download(path: string) {
    this.refreshHttpOptions();
    const options: {
      headers: {
        [header: string]: string | string[];
      };
      responseType: 'blob';
    } = { headers: this.httpOptions.headers, responseType: 'blob' };
    const url = path.startsWith('http') ? path : this.buildUrl(path);

    return this.http.get(url, options);
  }

  post<T>(path: string, data?: unknown) {
    this.refreshHttpOptions();
    return this.http.post<ApiUxRetour<T>>(this.buildUrl(path), data, this.httpOptions).pipe(map(result => result?.data));
  }

  put<T>(path: string, data?: any) {
    this.refreshHttpOptions();
    return this.http
      .put<ApiUxRetour<T>>(this.buildUrl(path), data, this.httpOptions)
      .pipe(map((result) => result?.data));
  }
}

class ApiUxRetour<T> {
  data: T;
}
